// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6127":"ed8174b7","7745":"fec7946d"}[chunkId] + ".chunk.css";
};